// extracted by mini-css-extract-plugin
export default {"pageContainer":"style_pageContainer__F9QVp","textContainer":"style_textContainer__UYFUZ"};